const { REACT_APP_NAME } = process.env;
import { Avatar, Box, Button, Card, CardContent, Chip, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Pagination, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography } from '@mui/material'

import PageContainer from '../container/PageContainer'
import { usePostBodyWithJwtMutation } from 'src/redux/api/cabinet';
import { useDispatch } from 'react-redux';
import { iLogout, updBalances, updProfileData } from 'src/redux/slices/app';
import { useEffect, useState } from 'react';
import { NumberFormat } from '../hooks/number-format/NumberFormat';
import { Alerting } from 'src/views/components_cabinet/Alerting';
import { useSearchParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { AppState } from 'src/store/Store';
import { AdminRozygrish } from './AdminRozygrish';
import { palette } from 'src/theme/style/palette';
// import dayjs from 'dayjs';

export const LotteryOfficeIndex = () => {
    const dispatch = useDispatch();
    const { data } = useSelector((state: AppState) => state.app);
    const [searchParams] = useSearchParams();
    const [getAlert, setgetAlert] = useState<{ type: number, msg: string } | undefined>(undefined);
    const [pagination, setPagination] = useState<any>(undefined);
    const [itemsBingo, setItemsBingo] = useState<any>(undefined);
    const [itemBingoData, setItemBingoData] = useState<any>(undefined);
    const [activeIndexBingo, setActiveIndexBingo] = useState<number>(0);
    const [winnersArray, setWinnersArray] = useState<any[]>([]);
    const [winnersDrawerState, setWinnersDrawerState] = useState(false);
    const params = new URLSearchParams(window.location.search);

    const programParam = searchParams.get('p');

    const updateWinnersDrawerState = () => {
        setWinnersDrawerState(!winnersDrawerState);
    }

    const [getData, { isLoading }] = usePostBodyWithJwtMutation();
    const getDataFunction = async (data: any = []) => {
        const jwt = localStorage.getItem('jwt');

        try {
            const payload = await getData({
                body: data,
                route: 'get-bingo',
                jwt
            }).unwrap();
            setItemsBingo(payload?.bingo || []);
            setItemBingoData(payload);
            setWinnersArray(payload?.awards?.data || []);
            setPagination(payload?.awards || undefined)
        } catch (error: any) {
            if (error.data?.message === 'Unauthenticated.') dispatch(iLogout());
            setgetAlert({ type: 2, msg: error.data.message });
        }
    }

    const handlePageChange = (event: React.ChangeEvent<unknown>, page: number) => {
        getDataFunction({ bingo: activeIndexBingo, page });
    };

    const [getDataBuy, { isLoading: isLoadingBuy }] = usePostBodyWithJwtMutation();
    const requestBuyBingo = async (data: any = []) => {
        const jwt = localStorage.getItem('jwt');

        try {
            const payload = await getDataBuy({
                body: data,
                route: 'paymant-bingo',
                jwt
            }).unwrap();

            setItemsBingo(payload?.bingo || []);
            setItemBingoData(payload);
            dispatch(updBalances(payload));

        } catch (error: any) {
            if (error.data?.message === 'Unauthenticated.') dispatch(iLogout());
            setgetAlert({ type: 2, msg: error.data.message });

        }
    }

    const startBuyBingo = (index: number) => {
        requestBuyBingo({ bingo: index })
    }

    const updateBingoArray = (index = 0, page = 1) => {
        setActiveIndexBingo(index);
        getDataFunction({ bingo: index, page });

        params.set('p', index.toString());

        const newUrl = `${window.location.pathname}?${params.toString()}`;
        window.history.replaceState({}, '', newUrl);
    }

    useEffect(() => {
        const index = !isNaN(Number(programParam)) ? Number(programParam) : 0;
        updateBingoArray(index);
    }, []);

    return (
        <>
            {getAlert && <Alerting get={getAlert} />}
            <PageContainer title={`${REACT_APP_NAME} | Лотерея`} description="Лотерея X10 Easy">
                <Box mb={3} display='flex' alignItems='center' justifyContent='space-between'>
                    <Typography variant='h4'>Лотерея</Typography>
                    {/* data?.is_admin */}
                    <Box display='flex' gap={1}>
                        {data?.is_admin && <AdminRozygrish mId={activeIndexBingo} />}
                        <Button variant='contained' disabled={isLoading} onClick={updateWinnersDrawerState}>Победители</Button>
                    </Box>
                </Box>

                {/* <pre>
                    {JSON.stringify(data?.is_admin, null, 2)}
                </pre> */}

                {isLoading ?
                    <Box minHeight={360} display='flex' alignItems='center' justifyContent='center'>
                        <CircularProgress />
                    </Box> :
                    !isLoading && itemsBingo?.length === 0 ?
                        <Box minHeight={360} display='flex' alignItems='center' justifyContent='center'>
                            <Typography variant='h4'>Нет данных</Typography>
                        </Box> :
                        !isLoading && itemsBingo?.length > 0 ?
                            <>
                                <Box display='flex' alignItems='center' gap={1} flexWrap='wrap' mb={3}>
                                    {itemsBingo?.map((el: any, i: number) => {
                                        return <Box key={i}>
                                            <Button
                                                sx={{ fontSize: '20px' }}
                                                variant={i === activeIndexBingo ? 'contained' : 'outlined'} onClick={() => updateBingoArray(i)}>
                                                {el?.name}&nbsp;—&nbsp;<span style={{ color: '#fff' }}>{el?.count || 0}</span>
                                            </Button>
                                            {/* {JSON.stringify(el)} */}
                                        </Box>

                                    })}
                                </Box>
                                <>
                                    <Card>
                                        <CardContent sx={{ p: 0 }}>
                                            <Typography textAlign='center' variant='h3'>
                                                {/* <pre>
                                                    {JSON.stringify(itemBingoData, null, 2)}
                                                </pre> */}
                                                {itemBingoData?.bingo[activeIndexBingo]?.name}
                                            </Typography>
                                            <Typography textAlign='center' variant='h6'>
                                                Выкуплено билетов {itemBingoData?.count_closed}/{itemBingoData?.count}
                                            </Typography>

                                            <Box display='flex' justifyContent='center' my={3}>
                                                <Button disabled={isLoadingBuy} variant='contained' onClick={() => startBuyBingo(activeIndexBingo)}>
                                                    Купить <NumberFormat number={itemBingoData?.bingo[activeIndexBingo]?.amount} />
                                                </Button>
                                            </Box>

                                            <Grid container spacing={1}>
                                                {Array.from({ length: itemBingoData?.count || 0 }).map((_, index) => (
                                                    <Grid item xs={4} sm={3} md={2} lg={1.15} xl={1.18} key={index}>
                                                        {itemBingoData?.data[index]?.login && <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'absolute', zIndex: 777, p: 1, borderRadius: '100%', backgroundColor: palette.blue, color: '#fff', width: '34px', height: '34px' }}>
                                                            <Box component="span" sx={{ fontWeight: 600, fontSize: '16px' }}>{itemBingoData?.data[index]?.ticket}</Box>
                                                        </Box>}

                                                        <Box
                                                            sx={{
                                                                width: '100%',
                                                                aspectRatio: '1 / 1', // квадрат
                                                                border: '1px solid #a59d9d',
                                                                backgroundColor: '#cecece',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                overflow: 'hidden',
                                                                position: 'relative',
                                                            }}
                                                        >
                                                            {itemBingoData?.data[index]?.avatar && (
                                                                <img
                                                                    alt=""
                                                                    src={itemBingoData?.data[index]?.avatar}
                                                                    style={{
                                                                        width: '100%',
                                                                        height: '100%',
                                                                        objectFit: 'cover',
                                                                        objectPosition: 'center',
                                                                        position: 'absolute',
                                                                        top: 0,
                                                                        left: 0,
                                                                    }}
                                                                />
                                                            )}
                                                        </Box>

                                                        <Typography variant="h6" textAlign='center'>
                                                            {itemBingoData?.data[index]?.login || 'Свободно'}
                                                        </Typography>
                                                    </Grid>
                                                ))}
                                            </Grid>

                                        </CardContent>
                                    </Card>
                                </>
                            </> :
                            <Box minHeight={360} display='flex' alignItems='center' justifyContent='center'>
                                <CircularProgress />
                            </Box>
                }

                <Dialog
                    maxWidth="lg"
                    fullWidth
                    open={winnersDrawerState}
                    onClose={updateWinnersDrawerState}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        Победители
                    </DialogTitle>
                    <DialogContent>
                        <Box minHeight={360}>
                            <TableContainer component={Paper}>
                                <Table aria-label="basic table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell><strong><Typography variant='h5'>№</Typography></strong></TableCell>
                                            <TableCell><strong><Typography variant='h5'>Тираж</Typography></strong></TableCell>
                                            <TableCell><strong><Typography variant='h5'>Билет</Typography></strong></TableCell>
                                            <TableCell><strong><Typography variant='h5'>Логин</Typography></strong></TableCell>
                                            <TableCell><strong><Typography variant='h5'>Дата</Typography></strong></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {winnersArray && winnersArray?.map((row, index) => (
                                            <TableRow
                                                key={(pagination.current_page - 1) * pagination.per_page + index + 1}
                                                sx={{
                                                    backgroundColor: index % 2 === 0 ? 'rgba(0, 0, 0, 0.04)' : 'transparent',
                                                    '&:hover': {
                                                        backgroundColor: 'rgba(0, 0, 0, 0.08)'
                                                    }
                                                }}
                                            >
                                                <TableCell component="th" scope="row">
                                                    <Typography variant='h5'>{((pagination.current_page - 1) * pagination.per_page + index + 1)}</Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <Typography variant='h5'>{row?.number}</Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <Typography variant='h5'>{row?.ticket || 0}</Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <Box display='flex' gap={1} alignItems='center'>
                                                        <Avatar src={row?.avatar || ''} />
                                                        <Typography variant='h5'>{row?.login}</Typography>
                                                    </Box>
                                                </TableCell>
                                                <TableCell>
                                                    <Box display='flex' alignItems='center'>
                                                        <Typography variant='h5'>
                                                            {row?.date}
                                                        </Typography>
                                                    </Box>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>

                            <Box mt={5} display="flex" justifyContent="center">
                                <Pagination
                                    count={pagination?.last_page}
                                    page={pagination?.current_page || 1}
                                    onChange={handlePageChange}
                                    color="primary"
                                />
                            </Box>
                        </Box>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={updateWinnersDrawerState} autoFocus>
                            Закрыть
                        </Button>
                    </DialogActions>
                </Dialog>
            </PageContainer>
        </>
    )
}
